import { Alert } from '@zopauk/react-components';
import { useServerExperiment } from '@zopauk/nextjs-amplitude-experiment/client';

type Payload =
  | {
      body?: string;
    }
  | undefined;

export const MaintenanceBanner = () => {
  const experimentsQuery = useServerExperiment(['web-platform-hub-maintenance']);

  if (experimentsQuery.data) {
    const payload = experimentsQuery.data['web-platform-hub-maintenance']?.payload as Payload;

    return payload?.body ? (
      <Alert data-automation="ZA.maintenance-banner" severity="warning" hasRoundedCorners className="mb-4">
        {payload.body}
      </Alert>
    ) : null;
  }

  return null;
};
